<template>
    <div class="diagnosis-section">
      <div class="diagnosis-content">
        <h3 class="mistica-style-h3">Momentos al vivir la experiencia Talentinus</h3>
        <div class="carousel-wrapper">
        <button class="carousel-btn" @click="prev">&#8592;</button>
        <div
            class="carousel-track"
            :class="slideDirection"
            @animationend="slideDirection = ''"
        >
            <div
                class="testimonial-card"
                v-for="(testimonial, i) in visibleTestimonials"
                :key="testimonial.author + '-' + i"
            >
                <img :src="testimonial.img" :alt="testimonial.author" class="testimonial-avatar" />
                <p class="testimonial-text">{{ testimonial.text }}</p>
                <span class="testimonial-author">{{ testimonial.author }}</span>
            </div>
        </div>
        <button class="carousel-btn" @click="next">&#8594;</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MeetSection',
    data() {
        return {
            testimonials: [
                {
                    img: require('@/assets/avatar/7a5dad598c511747e35680e328f53014ceba70a7.png'),
                    text: 'Yaritza',
                    author: 'Ahora entiendo por qué quería ser abogada... pero descubrí que psicología conecta mucho más con quién soy y lo que quiero hacer.'
                },
                {
                    img: require('@/assets/avatar/a101fd9d50cbbf23b789281e66fe6132d2d1892c.png'),
                    text: 'Diana',
                    author: 'Sabía que mi hijo era bueno en ciencias, pero no imaginaba el gran potencial que tenía para ir más lejos.'
                },
                {
                    img: require('@/assets/avatar/f0bac752ea07d86eec31326789ec2baa62497888.png'),
                    text: 'Ángel',
                    author: 'Estaba obsesionada con estudiar Química, pero al elegir Transformación Digital sentí una gran tranquilidad. Con mi personalidad, ahora sé que no habría logrado terminar Química.'
                },
                {
                    img: require('@/assets/avatar/f80ad9ac113345c81b12bdcf896d21884b18b3db.png'),
                    text: 'Adriana',
                    author: 'Me dio mucha tranquilidad ver que su plan tiene sentido: estudiar Derecho primero y luego hacer una maestría fuera de México para internacionalizar '
                },
            ],
            current: 0,
            cardsToShow: 3, // valor por defecto para web
            slideDirection: 'next'
        }
    },
    computed: {
        visibleTestimonials() {
        const { testimonials, current, cardsToShow } = this;
        const total = testimonials.length;
        let result = [];
        for (let i = 0; i < cardsToShow; i++) {
            result.push(testimonials[(current + i) % total]);
        }
        return result;
        }
    },
    mounted() {
        this.updateCardsToShow();
        window.addEventListener('resize', this.updateCardsToShow);
    },
    beforeUnmount() { // <-- Cambiado aquí
        window.removeEventListener('resize', this.updateCardsToShow);
    },
    methods: {
        updateCardsToShow() {
            this.cardsToShow = window.innerWidth <= 768 ? 1 : 3;
        },
        next() {
            this.slideDirection = 'next';
            this.current = (this.current + 1) % this.testimonials.length;
        },
        prev() {
            this.slideDirection = 'prev';
            this.current = (this.current - 1 + this.testimonials.length) % this.testimonials.length;
        }
    }
  }
  </script>
  
  <style scoped>
  .diagnosis-section {
    width: 100%;
    height: 700px;
    /* background: url('../../assets/img/Talentinus\ Conocenos.png') no-repeat center center; */
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .diagnosis-content {
    display: flex;
    max-height: 1440px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  .mistica-style-h3 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 64px;
    align-items: center;
    color: #C58911;
    padding-bottom: 5%;
    padding: 50px 80px;
    transform: scaleY(1.2);
  }
  
  .row.spacing-make {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}

.testimonial-card {
  background: #0F2030;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 24px 20px;
  max-width: 320px;
  min-width: 220px;
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.testimonial-text {
    color: #FDFDFD;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
}

.testimonial-author {
    color: #FDFDFD;
    leading-trim: both;
    text-edge: cap;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
}

.testimonial-avatar {
  width: 106px;
  height: 106px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 16px;
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
}

.carousel-btn {
  background: none;
  border: none;
  color: #C58911;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0 12px;
  transition: color 0.2s;
  user-select: none;
}
.carousel-btn:hover {
  color: #f5f5f5;
}

.carousel-track {
  display: flex;
  gap: 32px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
}

.carousel-track.next {
  animation: slide-left 0.8s;
}
.carousel-track.prev {
  animation: slide-right 0.8s;
}

@keyframes slide-left {
  0% { transform: translateX(60px); opacity: 0.5; }
  100% { transform: translateX(0); opacity: 1; }
}
@keyframes slide-right {
  0% { transform: translateX(-60px); opacity: 0.5; }
  100% { transform: translateX(0); opacity: 1; }
}

@media (max-width: 768px) {
  .diagnosis-section {
    height: auto;
    min-height: 320px;
    padding: 12px 0;
  }
  .diagnosis-content {
    gap: 12px;
    padding: 0 2vw;
  }
  .mistica-style-h3 {
    font-size: 1.3rem;
    padding: 18px 4vw;
    padding-bottom: 18px;
    word-break: break-word;
  }
  .carousel-wrapper {
    gap: 4px;
    flex-direction: column;
  }
  .carousel-btn {
    font-size: 2rem;
    padding: 0 4px;
  }
  .carousel-track {
    gap: 8px;
    flex-direction: row;
    width: 100%;
  }
  .testimonial-card {
    max-width: 95vw;
    min-width: 0;
    padding: 14px 6px;
    margin: 8px 0;
  }
  .testimonial-text {
    font-size: 1rem;
  }
  .testimonial-author {
    font-size: 12px;
  }
  .testimonial-avatar {
    width: 64px;
    height: 64px;
    margin-bottom: 8px;
  }
}
  </style>
